/* eslint-disable @stylistic/max-len */

const orderEntryFields = [
  'entryNumber',
  'product(brand,commercialCode,claim,images(FULL),name,price(formattedValue,value,currencyIso),discountedPrice(formattedValue,value),recommendedPrice(formattedValue,value),url,code,topCategoryName,subCategoryName,sisCategory,sisSubCategory,accessoryCategorisation,isAccessory,stock(stockLevel),productGenre,strikethroughPrice,familyAnneeN,family2)',
  'quantity',
  'strikethroughPrice'
];

export const addEntriesFields = [
  `entry(${orderEntryFields.join(',')})`,
  'quantity',
  'quantityAdded',
  'statusCode',
  'addedPriceWithDiscount(FULL)',
  'addedPriceWithoutDiscount(FULL)'
];
